"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudWatchRum = void 0;
const aws_rum_web_1 = require("aws-rum-web");
function cleanSearchParams(search) {
    if (!search)
        return '';
    const params = new URLSearchParams(search);
    params.delete('token');
    const cleaned = params.toString();
    return cleaned ? '?' + cleaned : '';
}
let awsRum = null;
const cloudWatchRumActions = {
    name: 'CloudWatchRum',
    init: ({ appVersion, cloudwatchRumConfig, tokens, awsRegion, isProduction, bypassProductionCheck, userId, }) => {
        var _a;
        if (!tokens['CloudWatchRum']) {
            console.warn('Cannot initialize CloudWatchRum. ApplicationId (token) is not defined.');
            return false;
        }
        const config = Object.assign({ allowCookies: true, sessionAttributes: Object.assign(Object.assign({}, (userId ? { userId } : {})), { searchParams: cleanSearchParams(((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) || '') }) }, cloudwatchRumConfig);
        if (!awsRum && (isProduction || bypassProductionCheck)) {
            try {
                awsRum = new aws_rum_web_1.AwsRum(tokens['CloudWatchRum'], appVersion || '1.0.0', awsRegion || 'us-east-2', config);
            }
            catch (error) {
                console.error(error);
                return false;
            }
        }
        return true;
    },
    identify: ({ userInfo, isProduction, bypassProductionCheck }) => {
        var _a;
        if (!isProduction && !bypassProductionCheck)
            return false;
        if (!awsRum) {
            console.warn('Cannot identify user in CloudWatchRum. CloudWatchRum is not initialized.');
            return false;
        }
        if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id)) {
            console.warn('Cannot set user in CloudWatchRum. userInfo.id is not defined.');
            return false;
        }
        try {
            awsRum.addSessionAttributes({
                userId: userInfo.id,
                searchParams: cleanSearchParams(((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) || ''),
            });
        }
        catch (error) {
            console.error('CloudWatchRum addSessionAttributes failed.');
            return false;
        }
        return true;
    },
    track: ({ isProduction, bypassProductionCheck, eventName, eventData, }) => {
        if (!isProduction && !bypassProductionCheck)
            return false;
        if (!awsRum) {
            console.warn('Cannot track event in CloudWatchRum. CloudWatchRum is not initialized.');
            return false;
        }
        try {
            awsRum.recordEvent(eventName, eventData || {});
        }
        catch (error) {
            console.error(error);
            return false;
        }
        return true;
    },
};
exports.CloudWatchRum = cloudWatchRumActions;
//# sourceMappingURL=index.js.map